/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioPlus } from './pages'

type TIdToPageMapStylioPlus = Record<PageIdStylioPlus, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_PLUS: TIdToPageMapStylioPlus = {
  [PageIdStylioPlus.AGE_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/AgeQuestion'),
  },
  [PageIdStylioPlus.URGE_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_plus/pages/urge/UrgePage'),
  },
  [PageIdStylioPlus.HAIR_COLOR_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioPlus.EYES_COLOR_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioPlus.JEWELRY_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/questions/JewelryQuestion').then(
        (m) => ({
          default: m.JewelryQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioPlus.BODY_SHAPE_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioPlus.STYLIO_TO_HELP_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/StylioToHelp'),
  },
  [PageIdStylioPlus.TALL_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/TallQuestion'),
  },
  [PageIdStylioPlus.WEIGHT_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/WeightQuestion'),
  },
  [PageIdStylioPlus.HIGHLIGHT_LOOK_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/HighlightLookQuestion'
      ).then((m) => ({
        default: m.HighlightLookQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/HighlightLookQuestion'),
  },
  [PageIdStylioPlus.CLOTHES_FIT_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/ClothesFitQuestion'
      ).then((m) => ({
        default: m.ClothesFitQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/ClothesFitQuestion'),
  },
  [PageIdStylioPlus.URGE_2_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioPlus.SHOPPING_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/questions/ShoppingQuestion').then(
        (m) => ({
          default: m.ShoppingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioPlus.STYLE_MOST_MATTERS_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioPlus.FAVORITE_COLORS_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant1StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant1StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant1StylioPlus'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_11_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant2StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant2StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant2StylioPlus'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_12_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant3StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant3StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant3StylioPlus'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_13_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant4StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant4StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant4StylioPlus'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_14_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant5StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant5StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant5StylioPlus'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_15_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant6StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant6StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant6StylioPlus'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_16_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant7StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant7StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant7StylioPlus'
      ),
  },
  [PageIdStylioPlus.LIKE_OR_DISLIKE_17_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant8StylioPlus'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant8StylioPlus,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/likeOrDislike/LikeOrDislikeVariant8StylioPlus'
      ),
  },
  [PageIdStylioPlus.STYLES_FEEL_LIKE_YOU_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/StylesFeelLikeYou'
      ).then((m) => ({
        default: m.StylesFeelLikeYou,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/StylesFeelLikeYou'),
  },
  [PageIdStylioPlus.URGE_4_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioPlus.BRAND_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/BrandQuestion'),
  },
  [PageIdStylioPlus.FIND_NEW_CLOTHES_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioPlus.NOTHING_TO_WEAR_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/NothingToWearQuestion'),
  },
  [PageIdStylioPlus.OLD_CLOTHES_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylioPlus.COMBINE_CLOTHES_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioPlus.OPTIMIZE_BUDGET_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioPlus.URGE_3_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioPlus.PREPARE_FLOW_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioPlus.EMAIL_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_plus/pages/email/Email'),
  },
  [PageIdStylioPlus.EMAIL_CONSENT_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_plus/pages/email/EmailConsent'),
  },
  [PageIdStylioPlus.SUBSCRIPTIONS_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioPlus.CANCEL_OFFER_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioPlus.SUB_UPSELL_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioPlus.UPSELL_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_plus/pages/upsell/Upsell'),
  },
  [PageIdStylioPlus.NAME_STYLIO_PLUS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_plus/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_plus/pages/email/Email'),
  },
  [PageIdStylioPlus.LAST_CHANCE_OFFER_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/last-chance-offer/LastChanceOffer'
      ).then((m) => ({
        default: m.LastChanceOffer,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_plus/pages/last-chance-offer/LastChanceOffer'
      ),
  },
  [PageIdStylioPlus.DOWNLOAD_STYLIO_PLUS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_plus/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_plus/pages/download-app/DownloadDefault'),
  },
}
